import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantRefService } from 'app/shared/services/tenant-ref.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
    const tenantService = inject(TenantRefService);

    const modifiedReq = req.clone({
        setHeaders: {
            'X-Tenant-Ref': tenantService.tenantRef
        }
    });

    return next(modifiedReq);
};
